import { Box, Typography } from '@mui/material';
import { isNil } from 'lodash';
import React, { useCallback, useContext, useEffect } from 'react';

import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { selectFlRlContoursAvailable, selectHeatMapsEnabled, selectLoadedSscfVersion, selectSelectedAntennaTypeId } from '../../../store';
import { requestAntennas } from '../../../store/antennas/actions';
import { requestFlHeatMaps, requestRlHeatMaps } from '../../../store/beams/actions';
import { selectAntennas } from '../../../store/index';
import appTheme from '../../common/theme/appTheme.json';
import { MapActionsContext, useSelectorWithMapId } from '../map/BaseMapContainer';
import OverlayToggle from './OverlayToggle';

const HeatMapsControls = () => {
  const dispatch = useDispatch();
  const antennas = useSelector(selectAntennas, shallowEqual);
  const flRlContoursAvailable = useSelector(selectFlRlContoursAvailable, shallowEqual);

  const mapActionsContext = useContext(MapActionsContext);
  const { disableHeatMaps, enableHeatMaps } = mapActionsContext.mapActions;

  const selectedAntennaTypeId = useSelectorWithMapId(selectSelectedAntennaTypeId);
  const heatMapsEnabled = useSelectorWithMapId(selectHeatMapsEnabled);
  const loadedSscfVersion = useSelectorWithMapId(selectLoadedSscfVersion);

  const disabled = isNil(selectedAntennaTypeId);

  useEffect(() => {
    if (antennas === undefined) {
      dispatch(requestAntennas());
    }
  }, [dispatch, antennas]);

  const setChecked = useCallback(
    (checked: boolean) => {
      if (!checked) {
        dispatch(disableHeatMaps());
      } else {
        if (selectedAntennaTypeId && antennas && antennas[selectedAntennaTypeId]) {
          let sscf = loadedSscfVersion;
          if (!sscf) {
            sscf = antennas[selectedAntennaTypeId].sscfFileVersion;
          }
          dispatch(
            requestFlHeatMaps(
              selectedAntennaTypeId,
              sscf,
            ),
          );
          dispatch(
            requestRlHeatMaps(
              selectedAntennaTypeId,
              sscf,
            ),
          );
          dispatch(enableHeatMaps());
        }
      }
    },
    [selectedAntennaTypeId, loadedSscfVersion, antennas, dispatch, disableHeatMaps, enableHeatMaps],
  );
  if (!flRlContoursAvailable && selectedAntennaTypeId) {
    return (
      <Box ml={3} mt={1} mb={2}>
        <Typography>
          <Box fontSize={12} color={appTheme.disabledTextColor}>
            Heat Map Contours Unavailable
          </Box>
        </Typography>
      </Box>
    );
  } else {
    return (
      <OverlayToggle
        checked={heatMapsEnabled}
        setChecked={setChecked}
        toggleId="heatMapContoursToggle"
        disabled={disabled}
        style={{
          marginTop: '12px',
          marginLeft: '8px',
        }}
        label={
          <Box
            component="span"
            color={disabled ? appTheme.disabledTextColor : appTheme.primaryTextColor}
            fontSize="14px"
          >
            Contours
          </Box>
        }
      />
    );
  }
};
export default HeatMapsControls;
